export enum UserType {
    PRIVATE = 1,
    COMPANY = 2,
}

export enum UserStatus {
    DELETED = 0,
    ACTIVE = 1,
    NEW = 2,
    BLOCKED = 5,
}

export enum ConfirmType {
    LINK = 1,
    CODE = 2,
}

export interface Profile {
    id: number;
    userId: number;
    type: UserType;
    name: string;
    patronymic: string;
    nikname: string;
    surname: string;
    restricted: boolean; // email not confirmed
    userStatus: UserStatus;
    deviceConfirmed: boolean;
    confirmType: ConfirmType;
    confirmDeviceResult: boolean; // TODO implement auth resource
    confirmDeviceMessage: string;

    sex: boolean; // true for male, female otherwise
    website: string;
    phone: string;
    email: string;
    altEmail: string;
    userRole: number;
    skype: string;

    companyName: string;
    inn: string;
    kpp: string;
    ogrn: string;

    country: string;
    zipCode: string;
    city: string;
    street: string;
    room: string;
    mailMatch: boolean;
    superadmin?: boolean;
    superadminUser?: boolean;
    superadminPermission?: boolean;
}

export const initialProfile: Readonly<Profile> = {
    id: 0,
    userId: 0,
    type: UserType.PRIVATE,
    restricted: true,
    userRole: null,
    userStatus: null,
    deviceConfirmed: false,
    confirmType: ConfirmType.LINK,
    confirmDeviceResult: null,
    confirmDeviceMessage: null,
    name: '',
    nikname: '',
    patronymic: '',
    surname: '',
    sex: true,
    website: '',
    phone: '',
    email: '',
    altEmail: '',
    skype: '',
    companyName: '',
    inn: '',
    kpp: '',
    ogrn: '',
    country: '',
    zipCode: '',
    city: '',
    street: '',
    room: '',
    mailMatch: true,
};
